<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-menu #menuContextuelItemCommande popup="popup" [model]="menuContextuelEntrees"></p-menu>

<p-toast key="synchronisationCTRL">
    <ng-template pTemplate="content">
        <div>
            <p>Synchronisation CTRL en cours...</p>
            <p-progressBar mode="indeterminate" styleClass="w-full" [style]="{ height: '6px' }"></p-progressBar>
            <small>Cette opération peut prendre plusieurs minutes.</small>
        </div>
    </ng-template>
</p-toast>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div class="grid" *ngIf="EstCharge()">
    <div class="col-12">

        <p-card styleClass="my-2">
            <p-table #dt [value]="bonsCommande" [columns]="selectedColumns" dataKey="bonCommandeId" autoLayout="true"
                sortMode="multiple" [multiSortMeta]="sortMeta" tableStyleClass="tableNormale" [rowHover]="true"
                [rows]="25" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
                [first]="tableParams.getValue().first ?? 0" [rows]="tableParams.getValue().rows ?? 25"
                [globalFilterFields]="['numero','dateEnvoi','fournisseur.nom','fournisseur.numero','projet.nom','employe.prenomNom']"
                [lazy]="true" [totalRecords]="totalRecords" [loading]="!chargementBdcComplete || !bonsCommande"
                (onLazyLoad)="onLazyLoad($event)">
                <ng-template pTemplate="caption">
                    <div class="flex align-content-center justify-content-between">
                        <div class="flex align-items-center gap-4 flex-wrap">
                            <span class="p-input-icon-left">
                                <p-inputGroup>
                                    <input autofocus pInputText type="text" [(ngModel)]="globalFilter"
                                        (input)="dt.filterGlobal($event.target.value, 'contains')"
                                        placeholder="Rechercher" />
                                    <p-inputGroupAddon>
                                        <p-checkbox [(ngModel)]="rechercheComplete" [binary]="true"
                                            (onChange)="rechercheCompleteChanged($event)"
                                            pTooltip="Rechercher dans les lignes de bon de commande"
                                            tooltipPosition="right" inputId="binary" />
                                    </p-inputGroupAddon>
                                </p-inputGroup>
                            </span>
                            <button *ngIf="estAutorise('bdc_creer')" pButton pRipple icon="pi pi-plus"
                                class="p-button-success" label="Ajouter" (click)="AjouterBdc()"></button>
                            <button pButton pRipple icon="pi pi-filter-slash" class="p-button-outlined"
                                pTooltip="Réinitialiser les filtres" tooltipPosition="bottom"
                                (click)="clearFilters(dt)"></button>
                        </div>
                        <h5 class="titreTableau m-0">Bons de commande</h5>
                        <div>
                            <app-selecteur-colonnes [colonnesDisponibles]="colonnesDisponibles"
                                [(ngModel)]="selectedColumns" (onReset)="reinitialiserColonnesSelectionnees()">
                            </app-selecteur-colonnes>
                        </div>
                    </div>
                </ng-template>

                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="numero">
                            <div class="flex justify-content-between align-items-center">
                                Numéro
                                <p-sortIcon field="numero"></p-sortIcon>
                                <p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="dateAchat">
                            <div class="flex justify-content-between align-items-center">
                                Date
                                <p-sortIcon field="dateAchat"></p-sortIcon>
                                <p-columnFilter type="date" field="dateAchat" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="fournisseur.nom">
                            <div class="flex justify-content-between align-items-center">
                                Fournisseur
                                <p-sortIcon field="fournisseur.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="fournisseur.nom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('projet')" pSortableColumn="projet.nom">
                            <div class="flex justify-content-between align-items-center">
                                Projet
                                <p-sortIcon field="projet.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="projet.nom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="statut.statutId">
                            <div class="flex justify-content-between align-items-center">
                                Statut
                                <p-sortIcon field="statut.statutId"></p-sortIcon>
                                <p-columnFilter field="statut.statutId" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
                                            (onChange)="filter($event.value)" optionLabel="nom" optionValue="statutId">
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('nbItems')" pSortableColumn="nbItems">
                            <div class="flex justify-content-between align-items-center">
                                Nb items
                                <p-sortIcon field="nbItems"></p-sortIcon>
                                <p-columnFilter type="numeric" field="nbItems" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('coutTotal')" pSortableColumn="coutTotal">
                            <div class="flex justify-content-between align-items-center">
                                Coût total
                                <p-sortIcon field="coutTotal"></p-sortIcon>
                                <p-columnFilter type="numeric" field="coutTotal" display="menu" currency="CAD"
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('employe')" pSortableColumn="employe.prenomNom">
                            <div class="flex justify-content-between align-items-center">
                                Employé
                                <p-sortIcon field="employe.prenomNom"></p-sortIcon>
                                <p-columnFilter type="text" field="employe.prenomNom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateEnvoi')" pSortableColumn="dateEnvoi">
                            <div class="flex justify-content-between align-items-center">
                                Date d'envoi
                                <p-sortIcon field="dateEnvoi"></p-sortIcon>
                                <p-columnFilter type="date" field="dateEnvoi" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('envoyeA')" pSortableColumn="courrielEnvoi">
                            <div class="flex justify-content-between align-items-center">
                                Envoyé à
                                <p-sortIcon field="courrielEnvoi"></p-sortIcon>
                                <p-columnFilter type="text" field="courrielEnvoi" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th style="min-width: 10rem;"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-bdc let-columns="columns">
                    <tr [class.bdc-sync-ctrl-erreur]="!!bdc.syncCtrlErreur">
                        <!--  <td style="text-align: center">
                            <button pButton (click)="OuvrirDetailBdc(bdc.bdcId)" type="button"
                                class="p-button-secondary" icon="pi pi-angle-double-right"></button>
                        </td> -->
                        <td>
                            <div class="flex align-items-center gap-2">
                                @if (bdc.indPrive) {
                                <span class="inline-flex text-color-secondary" pTooltip="Bon de commande privé"
                                    tooltipPosition="top">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" aria-label="Privé">
                                        <path d="M14 18a2 2 0 0 0-4 0" />
                                        <path d="m19 11-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11" />
                                        <path d="M2 11h20" />
                                        <circle cx="17" cy="18" r="3" />
                                        <circle cx="7" cy="18" r="3" />
                                    </svg>
                                </span>
                                }
                                @if (bdc.numero === '0') {
                                <a [routerLink]="estAutorise('bdc_detail') ? '/achat/' + bdc.bonCommandeId : null"
                                    class="inline-flex align-items-center"
                                    [pTooltip]="formaterErreurCtrl(bdc.syncCtrlErreur) || 'Bon de commande non synchronisé avec CTRL'"
                                    tooltipPosition="bottom">
                                    <p-tag severity="secondary" value="Aucun numéro"></p-tag>
                                </a>
                                } @else if (estAutorise('bdc_detail')) {
                                <a [routerLink]="'/achat/' + bdc.bonCommandeId"
                                    [pTooltip]="formaterErreurCtrl(bdc.syncCtrlErreur)"
                                    [tooltipDisabled]="!bdc.syncCtrlErreur"
                                    tooltipPosition="bottom"
                                    [innerHTML]="bdc.numero | highlight:globalFilter"></a>
                                } @else {
                                <span [pTooltip]="formaterErreurCtrl(bdc.syncCtrlErreur)"
                                    [tooltipDisabled]="!bdc.syncCtrlErreur"
                                    tooltipPosition="bottom"
                                    [innerHTML]="bdc.numero | highlight:globalFilter"></span>
                                }
                            </div>
                        </td>
                        <td [innerHTML]="(bdc.dateAchat | date:'yyyy-MM-dd') | highlight:globalFilter"></td>
                        <td [innerHTML]="bdc.fournisseur.nom | highlight:globalFilter"></td>
                        <td *ngIf="EstColonneSelectionnee('projet')"
                            [innerHTML]="bdc.projet?.nom | highlight:globalFilter"></td>
                        <td><span [class]="'statut ' + bdc.statut.nom.toLowerCase().replace(' ', '')">
                                {{bdc.statut.nom}}
                            </span></td>
                        <td *ngIf="EstColonneSelectionnee('nbItems')">{{bdc.nbItems}} ({{bdc.nbItemsTotal}})</td>
                        <td *ngIf="EstColonneSelectionnee('coutTotal')">{{bdc.coutTotal | currency:'CAD':'symbol'}}</td>
                        <td *ngIf="EstColonneSelectionnee('employe')"><app-employe-avec-emplacement
                                [employe]="bdc.employe"></app-employe-avec-emplacement></td>
                        <td *ngIf="EstColonneSelectionnee('dateEnvoi')"
                            [innerHTML]="(bdc.dateEnvoi | date:'yyyy-MM-dd HH:mm:ss') | highlight:globalFilter">
                        </td>
                        <td *ngIf="EstColonneSelectionnee('envoyeA')"
                            [innerHTML]="bdc.courrielEnvoi | highlight:globalFilter"></td>
                        <td class="celluleTableau">
                            <p-buttonGroup>
                                <p-button icon="pi pi-eye" severity="success" size="small"
                                    [routerLink]="['/achat', bdc.bonCommandeId]"></p-button>
                                <p-button icon="pi pi-external-link" severity="secondary" size="small" pTooltip="Aperçu"
                                    pTooltipPosition="top"
                                    (click)="OuvrirDetailBdcNouvelOnglet(bdc.bonCommandeId)"></p-button>
                                <p-button icon="pi pi-bars" severity="secondary" size="small"
                                    (onClick)="surMenuContextuelItem($event, bdc)"></p-button>
                            </p-buttonGroup>
                        </td>
                    </tr>
                    @for (item of bdc.itemsBonCommande; track item.itemBonCommandeId; let isLast = $last) {
                    <tr class="sub-row">
                        <td class="connector-cell">
                            <div class="connector-line" [class.has-next]="!isLast"></div>
                        </td>
                        <td [innerHTML]="item?.item?.numero | highlight:globalFilter"></td>
                        <td [innerHTML]="item?.item?.description | highlight:globalFilter"></td>
                        <td [innerHTML]="item?.item?.marque | highlight:globalFilter"></td>
                        <td [innerHTML]="item?.item?.modele | highlight:globalFilter"></td>
                        <td [innerHTML]="item?.noFournisseur | highlight:globalFilter"></td>
                        <td [attr.colspan]="selectedColumns.length - 1">
                    </tr>
                    }
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="selectedColumns.length + 5" class="text-center p-3">Aucun bon de commande.
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>


</div>

<p-sidebar [(visible)]="afficherDetailBdc" [style]="{width:'95%'}" position="left">
    <app-detail-bdc [bdcId]="detailBdcId" *ngIf="afficherDetailBdc"></app-detail-bdc>
</p-sidebar>